module.exports = __webpack_public_path__ + "static/media/moschino_case_man.81d8e956.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/moschino_case_man.png
// module id = 800
// module chunks = 0